import { Css } from "@homebound/beam";
import { BudgetSuperDrawer_ProjectItemFragment } from "src/routes/projects/budget/components/BudgetSuperDrawer.generated";
import { centsToDollars, formatNumberToString } from "src/utils";
import { BudgetBillsTable } from "../BudgetBillsTable";
import { BudgetChangeEventsTable } from "../BudgetChangeEventsTable";
import { BudgetCommitmentsTable } from "../BudgetCommitmentsTable";

export type BudgetDetailsTabProps = { projectItems: BudgetSuperDrawer_ProjectItemFragment[]; projectId: string };

export function BudgetDetailsTab(props: BudgetDetailsTabProps) {
  const { projectItems, projectId } = props;
  const changeEventLineItems = projectItems.flatMap((pi) => pi.changeEventLineItems);
  const changeEventsTotalCosts = changeEventLineItems
    .map((celi) => celi.changeEvent)
    .unique()
    .sum((celi) => celi.totalCostInCents);

  return (
    <div css={Css.df.fdc.gap3.$}>
      <BudgetChangeEventsTable projectItems={projectItems} projectId={projectId} title="Change Events" />

      <div css={Css.df.fdr.mb5.mdSb.$}>
        <div>Total Change Events</div>
        <div data-testid="totalChangeEvents" css={Css.mlPx(550).$}>
          ${formatNumberToString(centsToDollars(changeEventsTotalCosts))}
        </div>
      </div>

      <div css={Css.hPx(1).mb3.bgGray200.$} />
      <BudgetCommitmentsTable projectItems={projectItems} />

      <div css={Css.hPx(1).my3.bgGray200.$} />
      <BudgetBillsTable projectId={projectId} projectItems={projectItems} />
    </div>
  );
}
